import React, { Component } from 'react';
import {Alert, Button, Form, FormGroup, FormText, Input, Label} from 'reactstrap';
import './SetPassword.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {setNewPassword} from '../../store/resetPasswordActions';
import { push } from 'connected-react-router';
import {getLogin} from '../../store/loginActions';

class SetPassword extends Component {
  constructor(props) {
    super(props);

    this.state = {
      newPassword: ''
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.success === true && !prevProps.success) {
      this.props.getLogin();
      window.setTimeout(() => {
        this.props.changePage('/');
      }, 5000);
    }
  }

  onSubmit(evt) {
    const params = new URLSearchParams(window.location.search);

    evt.preventDefault();

    this.props.setNewPassword(params.get('t'), this.state.newPassword);
    return false;
  }

  render() {
    return (
      <div className="setpassword-container">
        {this.props.error && <Alert color="danger">{this.props.error}</Alert>}
        {this.props.success && <Alert color="success">Your password was successfully set. We'll redirect you back to the application shortly.</Alert>}
        <Form className={'setpassword-form'} onSubmit={e => this.onSubmit(e)}>
          <h2 className="mb-4">Update your password</h2>
          <FormGroup>
            <Label for="password">New password</Label>
            <Input
              type="password"
              id="password"
              placeholder="********"
              onChange={e => this.setState({ newPassword: e.target.value })}
              minLength={8}
              required
            />
            <FormText color="muted">Min. 8 symbols</FormText>
          </FormGroup>

          <Button color="primary" className="btn-block">
            Update password
          </Button>
        </Form>
      </div>
    );
  }
}

export { SetPassword };

const mapStateToProps = ({resetPassword}) => {
  return {
    error: resetPassword.error,
    success: resetPassword.setNewPasswordSuccess
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      setNewPassword,
      changePage: route => push(route),
      getLogin
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SetPassword);



// WEBPACK FOOTER //
// ./src/components/SetPassword/SetPassword.js